// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"412359a9","505":"014a1906","572":"73d695e0","807":"e82722f6","859":"86b5324d"}[chunkId] + ".chunk.js";
};